import { put, call, takeLatest, select } from 'redux-saga/effects';

import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';

import { formatError } from '../../../libs';
import categoryAPI from '../../api/category';
import searchAPI from '../../api/search';
import { Creators as CategoryCreators } from '../../reducers/category';
import { Creators as GlobalCreators } from '../../reducers/global';
import { Types, Creators as SearchCreators } from '../../reducers/search';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function parseToJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}

function* searchParam({ param, dataPreLoaded = null, extraParams = {} }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const token = yield select(getToken);

    let typeSlug = '/busca';
    let slugToFind = { content: param.value };

    if (param.field === 'filter' && param.value.length) {
      if (param.item === 'marcaProduto') {
        typeSlug = `/marca/${param.value[0].value}`;
      }

      if (param.item === 'tag') {
        typeSlug = `/busca`;
      }

      slugToFind = {};
    }

    const search = !isEmpty(dataPreLoaded)
      ? dataPreLoaded
      : yield call(searchAPI.getSlug, typeSlug, slugToFind, siteId) || {};

    // if (!search || isEmpty(search)) {
    //   throw `Página não encontrada`;
    // }

    const searchQuery = {
      sortBy: param.sortBy || app.getIn(['config', 'components', 'Category', 'sortBy']),
      limit: app.getIn(['config', 'components', 'Category', 'pagination', 'limit']),
      offset: app.getIn(['config', 'components', 'Category', 'pagination', 'offset']),
      filter: {},
      content: {},
      ...extraParams,
    };

    delete searchQuery.filtro;

    if ((param.field !== 'busca' && param.value) || extraParams.filtro) {
      const parsedFilter = parseToJson(extraParams.filtro) || param.value;
      const filter = !isArray(parsedFilter) ? [parsedFilter] : parsedFilter;

      filter.forEach((item) => {
        searchQuery.filter[item.id] = [...(searchQuery.filter[item.id] || []), ...[item]].filter((obj) => !!obj);
      });
    }

    const searchQueryFilter = [];
    forEach(searchQuery.filter, (item) => searchQueryFilter.push(JSON.stringify(...item)));

    const query = { ...searchQuery };

    delete query.filter;
    delete query.content;

    if (searchQueryFilter.length) {
      query.filter = searchQueryFilter.toString();
    }

    if (param.field === 'busca') {
      searchQuery.content = param.value;
      query.content = param.value;
    }

    const data = {
      id: search.id || null,
      url: search.url || null,
      seo: search.seo || {},
      content: search.content || null,
    };

    const {
      aggregations = [],
      _result = {},
      products = [],
      searchSuggestions,
    } = yield call(categoryAPI.getProducts, query, siteId, token);

    const sidebar = [
      { ...aggregations.find((item) => item.id === 'categoria'), multiple: false },
      {
        ...aggregations.find((item) => item.id === 'segmentoPrincipal'),
        multiple: true,
        visible: true,
      },
      {
        ...aggregations.find((item) => item.id === 'marcaProduto'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
        visible: !(param.item === 'marcaProduto'),
      },
      {
        ...aggregations.find((item) => item.id === 'tabelaPreco'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
        visible: true,
      },
      {
        ...aggregations.find((item) => item.id === 'definicao'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
        visible: true,
      },
    ];

    const filters = {
      sortBy: app.getIn(['config', 'components', 'Category', 'sortBy']),
      sortByOptions: app.getIn(['config', 'components', 'Category', 'sortByOptions']).filter((item) => item.active),
      sidebar,
    };

    yield put(SearchCreators.searchParamSuccess({ param, searchSuggestions, totalProducts: _result.total || 0 }));

    yield put(
      CategoryCreators.getCategorySuccess({
        data,
        filters,
        searchQuery,
        products,
        totalProducts: _result.total || 0,
      })
    );
  } catch (error) {
    yield put(GlobalCreators.errorApp(formatError(error)));
    yield put(SearchCreators.searchParamError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEARCH_PARAM_REQUEST, searchParam);
}
